<template>
  <div class="card-body p-10 bg-white">
    <div class="flex justify-center items-center">
      <div class="mr-10">
        <div v-if="certificate.enabled">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="69"
            fill="none"
            viewBox="0 0 64 69"
          >
            <path
              fill="#A6FFE4"
              d="M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z"
            />
            <path
              fill="#E56353"
              d="M34.96 10.802h-5.84c-3.581 0-6.218 3.353-5.372 6.833l1.67 6.881c.336 1.38.917 2.689 1.716 3.863 1.336 1.962 2.05 4.28 2.05 6.654v1.689h5.712v-1.69c0-2.373.714-4.691 2.05-6.653.799-1.175 1.38-2.483 1.715-3.863l1.671-6.88c.846-3.481-1.79-6.834-5.372-6.834z"
            />
            <path
              fill="#64798A"
              d="M27.738 36.722h8.605c.626 0 1.133.507 1.133 1.133v3.288H26.604v-3.288c0-.626.508-1.133 1.134-1.133z"
            />
            <path
              fill="#DC8744"
              d="M16.214 41.143h31.652c.626 0 1.134.508 1.134 1.134v8.056c0 .313-.254.567-.567.567H15.647c-.313 0-.567-.254-.567-.567v-8.056c0-.626.508-1.134 1.134-1.134z"
            />
            <path
              fill="#3A556A"
              d="M17.823 50.9h28.435v1.273c0 .626-.508 1.134-1.134 1.134H18.956c-.626 0-1.133-.508-1.133-1.134V50.9z"
            />
            <path
              fill="#404B58"
              d="M23.738 46.618c-.385 0-.697-.311-.697-.696v-1.367c0-.385.312-.696.697-.696.384 0 .696.311.696.696v1.367c0 .385-.311.696-.696.696zM40.052 46.618c-.385 0-.697-.311-.697-.696v-1.367c0-.384.312-.696.697-.696.385 0 .696.312.696.696v1.367c0 .385-.312.697-.696.697zM31.937 47.67c-1.033 0-2.016-.448-2.696-1.229-.253-.29-.222-.73.068-.982.29-.253.73-.223.982.067.416.477 1.015.75 1.646.75.63 0 1.23-.273 1.646-.75.253-.29.692-.32.982-.067.29.252.32.692.068.982-.68.78-1.663 1.228-2.696 1.228z"
            />
            <circle cx="53.272" cy="58.451" r="10.358" fill="#54CAA6" />
            <path
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M48.832 59.043l2.943 3.107 6.306-6.659"
            />
          </svg>
        </div>
        <div v-else>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="66"
            height="71"
            fill="none"
            viewBox="0 0 66 71"
          >
            <path
              fill="#E0E0E0"
              d="M32 64c17.674 0 32-14.326 32-32C64 14.327 49.675 0 32 0 14.327 0 0 14.327 0 32c0 17.674 14.327 32 32 32z"
            />
            <path
              fill="#ACACAC"
              d="M34.818 11.838h-5.555c-3.407 0-5.915 3.19-5.11 6.5l1.59 6.546c.318 1.313.871 2.557 1.631 3.674 1.27 1.867 1.95 4.072 1.95 6.33v1.607h5.433v-1.607c0-2.258.68-4.463 1.95-6.33.76-1.117 1.313-2.361 1.632-3.674l1.59-6.545c.804-3.31-1.704-6.5-5.11-6.5z"
            />
            <path
              fill="#7E7E7E"
              d="M27.948 36.495h8.185c.596 0 1.079.482 1.079 1.078V40.7H26.87v-3.128c0-.596.482-1.078 1.078-1.078z"
            />
            <path
              fill="#AAA"
              d="M16.986 40.7h30.11c.595 0 1.078.483 1.078 1.079v7.663c0 .298-.242.54-.54.54H16.448c-.298 0-.54-.242-.54-.54V41.78c0-.596.483-1.079 1.079-1.079z"
            />
            <path
              fill="#696969"
              d="M18.517 49.981h27.048v1.212c0 .595-.482 1.078-1.078 1.078H19.595c-.596 0-1.078-.483-1.078-1.078V49.98z"
            />
            <path
              fill="#404B58"
              d="M24.143 45.909c-.366 0-.662-.297-.662-.663v-1.3c0-.366.296-.662.662-.662.366 0 .663.296.663.662v1.3c0 .366-.297.663-.663.663zM39.662 45.909c-.366 0-.663-.297-.663-.663v-1.3c0-.366.297-.662.663-.662.366 0 .662.296.662.662v1.3c0 .366-.296.663-.662.663zM31.943 44.643c.983 0 1.918.425 2.564 1.167.24.276.212.695-.064.935-.276.24-.694.212-.934-.064-.396-.454-.966-.714-1.566-.714-.6 0-1.17.26-1.566.714-.24.276-.658.304-.934.064s-.305-.659-.065-.934c.648-.743 1.582-1.168 2.565-1.168z"
            />
            <circle cx="53.272" cy="58.452" r="10.358" fill="#7E7E7E" />
            <circle
              cx="53.5"
              cy="58.5"
              r="11.5"
              stroke="#fff"
              stroke-width="2"
            />
            <path
              fill="#fff"
              fill-rule="evenodd"
              d="M53.236 52.673c.42 0 .764.343.764.764v4.584c0 .848-.688 1.528-1.528 1.528h-4.585c-.42 0-.764-.343-.764-.764 0-.42.344-.764.764-.764h4.585v-4.584c0-.428.343-.764.764-.764z"
              clip-rule="evenodd"
            />
            <path
              fill="#fff"
              d="M52.472 58.021v.5h.5v-.5h-.5zm.764-4.848c.144 0 .264.12.264.264h1c0-.697-.568-1.264-1.264-1.264v1zm.264.264v4.584h1v-4.584h-1zm0 4.584c0 .57-.462 1.028-1.028 1.028v1c1.115 0 2.028-.902 2.028-2.028h-1zm-1.028 1.028h-4.585v1h4.585v-1zm-4.585 0c-.144 0-.264-.12-.264-.264h-1c0 .697.568 1.264 1.264 1.264v-1zm-.264-.264c0-.144.12-.264.264-.264v-1c-.696 0-1.264.568-1.264 1.264h1zm.264-.264h4.585v-1h-4.585v1zm5.085-.5v-4.584h-1v4.584h1zm0-4.584c0-.149.116-.264.264-.264v-1c-.693 0-1.264.556-1.264 1.264h1z"
            />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <p
          v-html="
          $sanitize($t('message.certificates.certificatesList.createdBy', {
              input: certificate.full_name,
            }))
          "
          class="text-lg mb-1"
        ></p>
        <p
          v-html="
          $sanitize($t('message.certificates.certificatesList.creationDate', {
              input: creationDate,
            }))
          "
          class="text-base mb-1"
        >
          {{}}
        </p>
        <zt-badge
          class="text-sm"
          square
          :color="certificate.enabled ? '03a9f4' : 'ff3d3e'"
        >
          {{
            $t(
              `message.certificates.certificatesList.${
                certificate.enabled ? "validDate" : "expiredDate"
              }`,
              { input: expirationDate }
            )
          }}
        </zt-badge>
      </div>
      <div class="flex flex-col">
        <zt-button
          data-vs-button="open-modal"
          outlined
          class="text-zt-primary-200 p-0 text-base"
          @click="modalActive = true"
          >{{
            $t("message.certificates.certificatesList.btnCertificate")
          }}
        </zt-button>
        <zt-button
          v-if="certificate.enabled"
          data-vs-button="open-modal-expire"
          outlined
          class="text-zt-primary-200 p-0 text-base mt-3"
          @click="$emit('open-expire-modal')"
          >{{
            $t("message.certificates.certificatesList.btnExpireCertificate")
          }}
        </zt-button>
      </div>

      <zt-modal
        :active="modalActive"
        @close="modalActive = false"
        class="modal-certificate"
      >
        <template slot="modal-header">
          <div class="p-4 font-semibold">
            <h4>
              {{
                $t(
                  "message.certificates.certificatesList.certificateModal.modalTitle"
                )
              }}
            </h4>
          </div>
        </template>
        <template>
          <modal-body :certificate="certificate" />
        </template>
        <template slot="modal-footer">
          <div
            class="zt-modal-footer flex justify-end items-center p-4 bg-zt-dark-200"
          >
            <zt-button
              @click="modalActive = false"
              data-vs-button="open-modal"
              class="mr-1 text-base font-semibold"
              >{{
                $t(
                  "message.certificates.certificatesList.certificateModal.closeBtn"
                )
              }}</zt-button
            >
          </div>
        </template>
      </zt-modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import modalBody from "./CertificateModalBody";
export default {
  name: "certificateCard",
  components: {
    modalBody,
  },
  props: {
    certificate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      modalActive: false,

    };
  },
  computed: {
    creationDate() {
      return moment(
        this.certificate.creationDate,
        "DD-MM-YYYY hh:mm:ss"
      ).format("DD/MM/YYYY");
    },
    expirationDate() {
      return moment(
        this.certificate.expirationDate,
        "DD-MM-YYYY hh:mm:ss"
      ).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-body {
  border-radius: 5px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px 0 rgba(0, 0, 0, 0.12),
    0 3px 4px 0 rgba(0, 0, 0, 0.14);
}

.modal-certificate {
  z-index: 500;
}
</style>
